import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"

const useBrands = () => {
  const [brands, setBrands] = useState([])
  const {
    data: brandResponse,
    isLoading,
    isError,
    isFetching,
  } = useCustomQuery(["brand-all"], "brand/all")

  useEffect(() => {
    if (brandResponse?.data) {
      setBrands(brandResponse.data)
    }
  }, [brandResponse])
  return {
    brands,
    isLoading,
    isError,
    isFetching,
    setBrands,
  }
}

export default useBrands
